module.exports = __webpack_public_path__ + "static/img/index_icon1.d3a3757.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_icon1.png
// module id = RWnN
// module chunks = 1